import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  tracesSampleRate: 0.1,
});

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host:          process.env.REACT_APP_POSTHOG_HOST,
  defaults:          '2026-01-30',
  capture_pageview:  true,
  autocapture:       true,
  session_recording: { enabled: true },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

reportWebVitals();